import WoocommerceUserDetailsCollectorComponent from './WoocommerceUserDetailsCollectorComponent';
import { Form } from 'antd';


const WoocommerceUserDetailsCollector = Form.create({ name: "get_info" })(WoocommerceUserDetailsCollectorComponent);


export default WoocommerceUserDetailsCollector;